
import { supabase } from "@/integrations/supabase/client";

export const fetchSubscriptionStats = async () => {
  try {
    // Get all active subscriptions from strategy_subscriptions table
    const { data: subscriptions, error } = await supabase
      .from('strategy_subscriptions')
      .select('*');
    
    if (error) {
      console.error("Error fetching subscriptions:", error);
      throw error;
    }

    // Get current date for comparison
    const currentDate = new Date();

    // Count monthly and yearly subscriptions that are either active or have a future end date
    const activeSubscriptions = subscriptions.filter(sub => sub.active === true);
    const canceledWithFutureDate = subscriptions.filter(sub => 
      sub.active === false && 
      sub.next_billing_date && 
      new Date(sub.next_billing_date) > currentDate
    );

    return {
      total: activeSubscriptions.length,
      monthly: activeSubscriptions.filter(sub => sub.plan === 'monthly').length,
      yearly: activeSubscriptions.filter(sub => sub.plan === 'yearly').length,
      activeCanceled: canceledWithFutureDate.length,
      subscriptions: [...activeSubscriptions, ...canceledWithFutureDate]
    };
  } catch (error) {
    console.error("Failed to fetch subscription stats:", error);
    throw error;
  }
};
